import type { EdgeTypes } from '@xyflow/react';
import { OlEdge } from './OlEdge';

export const edgeTypes: EdgeTypes = {
  ol: OlEdge,
};
